import dataIdFromObject, { redefinedTypes } from "./dataIdFromObject";
import { clientStateVar, deviceSizeVar } from "./reactiveVars";

export default ({ options }) => {
  const keyFields = redefinedTypes.reduce(
    (memo, key) => ({
      ...memo,
      [key]: {
        keyFields: dataIdFromObject
      }
    }),
    {}
  );

  return {
    ...options,
    ...keyFields,
    Query: {
      fields: {
        clientState: {
          read() {
            return {
              deviceSize: deviceSizeVar(),
              state: clientStateVar()
            };
          }
        }
      }
    }
  };
};
